<template>
  <v-card flat class="px-6">
    <v-card-text>
      <v-row>
        <v-col cols="12">
          <RichTextEditor
            v-model="localDetails.cargoDescription"
            :label="$t('tslOrders.fields.cargoDescription')"
            toolbar-type="full"
            @input="emitUpdate"
          />
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12">
          <RichTextEditor
            v-model="localDetails.notes"
            :label="$t('tslOrders.fields.notes')"
            toolbar-type="full"
            @input="emitUpdate"
          />
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12">
          <v-select
            v-model="localDetails.ftlLtl"
            :label="$t('tslOrders.fields.ftlLtl')"
            :items="freightTypes"
            item-text="description"
            item-value="id"
            outlined
            dense
            multiple
            clearable
            @change="emitUpdate"
          />
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12">
          <RichTextEditor
            v-model="localDetails.customsInfo"
            :label="$t('tslOrders.fields.customsInfo')"
            toolbar-type="simple"
            @input="emitUpdate"
          />
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12">
          <RichTextEditor
            v-model="localDetails.cabotageInfo"
            :label="$t('tslOrders.fields.cabotageInfo')"
            toolbar-type="simple"
            @input="emitUpdate"
          />
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12">
          <RichTextEditor
            v-model="localDetails.adrInfo"
            :label="$t('tslOrders.fields.adrInfo')"
            toolbar-type="simple"
            @input="emitUpdate"
          />
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import RichTextEditor from '@/components/forms/RichTextEditor'

export default {
  name: 'DetailsTab',
  components: {
    RichTextEditor
  },
  props: {
    details: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      localDetails: {
        notes: this.details.notes || '',
        cargoDescription: this.details.cargoDescription || '',
        ftlLtl: this.details.ftlLtl || [],
        customsInfo: this.details.customsInfo || '',
        cabotageInfo: this.details.cabotageInfo || '',
        adrInfo: this.details.adrInfo || ''
      }
    }
  },
  computed: {
    freightTypes () {
      return this.$store.getters.enums.freightTypes || []
    }
  },
  watch: {
    details: {
      deep: true,
      handler (newDetails) {
        this.localDetails = {
          notes: newDetails.notes || '',
          cargoDescription: newDetails.cargoDescription || '',
          ftlLtl: newDetails.ftlLtl || [],
          customsInfo: newDetails.customsInfo || '',
          cabotageInfo: newDetails.cabotageInfo || '',
          adrInfo: newDetails.adrInfo || ''
        }
      }
    }
  },
  methods: {
    emitUpdate () {
      this.$emit('update', this.localDetails)
    }
  }
}
</script>
